import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MeetingViewModelService } from '../../meeting-view-model/meeting-view-model.service';
import { AvailableServices } from '../../meeting-services';

@Component({
  selector: 'integrations-service-connection-status',
  templateUrl: './connection-status.component.html',
  standalone: false,
})
export class ConnectionStatusComponent implements OnInit {
  @Input() service: AvailableServices;
  @Input() useAlternateStyling: boolean;
  serviceConnected$: Observable<boolean>;

  constructor(private readonly viewModel: MeetingViewModelService) {}

  ngOnInit(): void {
    this.serviceConnected$ = this.viewModel.isServiceConnected$(this.service);
  }
}
